(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["admiral-brand-history"] && !Shopify.designMode) return;
  try {
    
  AOS.init({
    once: true,
  });

  const slides =$(".img-wrap").find("img");
  const slideLength = slides.length;
  const pagenation_line = $(".pagenation-line");
  if( slideLength > 1) {
    let now = 0;
    let next = 1;
    const fade = 2000;
    const show = 5000;
    slides.hide();
    pagenation_line.css('background-color', '#fff');
    slides.eq(0).show();
    pagenation_line.eq(0).css('background-color', '#DB1633');
    timerId = setInterval(function(){
      slides.eq(now % slideLength).fadeOut(fade);
      pagenation_line.css('background-color', '#fff');
      slides.eq(next % slideLength).fadeIn(fade);
      pagenation_line.eq(next % slideLength).css('background-color', '#DB1633');
      now++;
      next++;
    }, show);
  }

  var point1;
  var point2;
  var point3;
  var point4;
  var point5;
  var footer;
  var flag_point1 = true;
  var flag_point2 = true;
  var flag_point3 = true;
  var flag_point4 = true;
  var flag_point5 = true;

  $(window).on('load', function () {
    point1 = $('#li-point-1').offset().top + $('#li-point-1').outerHeight();
    point2 = $('#li-point-2').offset().top + $('#li-point-2').outerHeight();
    point3 = $('#li-point-3').offset().top + $('#li-point-3').outerHeight();
    point4 = $('#li-point-4').offset().top + $('#li-point-4').outerHeight();

    if (window.matchMedia("(max-width: 768px)").matches) {
      point5 = $('#li-point-5').offset().top + $('#li-point-5').outerHeight() + 800;      
    } else {
      point5 = $('#li-point-5').offset().top + $('#li-point-5').outerHeight() - 200;
    }
    footer = $('.brand-history-footer').offset().top + $('.brand-history-footer').outerHeight();
  });

    $(window).scroll(function () {
    if ($(window).scrollTop() + $(window).height() > point1 && $(window).scrollTop() + $(window).height() < point2 ) {
      $('.history-list-menu li').removeClass('li-back-red');
      $('.history-list-menu li').eq(0).addClass('li-back-red');
    } else if ($(window).scrollTop() + $(window).height() >= point2 && $(window).scrollTop() + $(window).height() < point3 ) {
      $('.history-list-menu li').removeClass('li-back-red');
      $('.history-list-menu li').eq(1).addClass('li-back-red');
    } else if ($(window).scrollTop() + $(window).height() >= point3 && $(window).scrollTop() + $(window).height() < point4 ) {
      $('.history-list-menu li').removeClass('li-back-red');
      $('.history-list-menu li').eq(2).addClass('li-back-red');
    } else if ($(window).scrollTop() + $(window).height() >= point4 && $(window).scrollTop() + $(window).height() < point5 ) {
      $('.history-list-menu li').removeClass('li-back-red');
      $('.history-list-menu li').eq(3).addClass('li-back-red');
    } else if ($(window).scrollTop() + $(window).height() >= point5 ) {
      $('.history-list-menu li').removeClass('li-back-red');
      $('.history-list-menu li').eq(4).addClass('li-back-red');
    } else {
      $('.history-list-menu li').removeClass('li-back-red');
    }

      var disp_pos = $(this).scrollTop() + ( $(window).innerHeight() / 2 );

        $('.count_num').each(function(index) {
          var obj_offset_top = $(this).offset().top - 300;
          if ( index == 1 ) {
            obj_offset_top = $(this).offset().top - 100;
          }
          if ( !$(this).hasClass('count_start') ) {
            if( obj_offset_top < disp_pos) {
              $(this).addClass('count_start');
                var target = $(this);
                var startNum = target.attr('data-start');
                var endNum = target.attr('data-end');
                if( startNum != endNum ) {
                    var countNum = startNum;
                    var timerFunc = setInterval(function() {
                        if( startNum < endNum ) {
                          countNum++;
                        } else {
                          countNum++;
                        }
                        target.text(countNum);
                        if( countNum == endNum ) {
                            clearInterval(timerFunc);
                            target.attr('data-start', endNum);
                        }
                    }, 40 );
                }
            }
          }
        });
        $('.count_num2').each(function(index) {
          var obj_offset_top2 = $(this).offset().top - 300;
          if ( !$(this).hasClass('count_start') ) {
            if( obj_offset_top2 < disp_pos ) {
              $(this).addClass('count_start');
                var target2 = $(this);
                var startNum2 = target2.attr('data-start2');
                var endNum2 = target2.attr('data-end2');
                if( startNum2 != endNum2 ) {
                    var countNum2 = startNum2;
                    var timerFunc2 = setInterval(function() {
                        if( startNum2 < endNum2 ) {
                            countNum2++;
                        } else {
                          countNum2++;
                        }
                        target2.text(countNum2);
                        if( countNum2 == endNum2 ) {
                            clearInterval(timerFunc2);
                            target2.attr('data-start2', endNum2);
                        }
                    }, 40 );
                }
            }
          }
        });
  });

  $('a[href^="#"]').click(function(){
  var adjust = 20;
  var speed = 400;
  var href= $(this).attr("href");
  var target = $(href == "#" || href == "" ? 'html' : href);
  var position = target.offset().top + adjust;
  
  if ( href == '#li-point-5' ) {
    position = target.offset().top  + 200;
  } else if ( href == '#li-point-4' ) {
    position = target.offset().top  + 300;
  } else if ( href == '#li-point-1' ) {
    position = target.offset().top  - 200;
  }
  
  if (window.matchMedia("(max-width: 768px)").matches) {
    if ( href == '#li-point-4' ) {
      position = target.offset().top  + 250;
    } else if ( href == '#li-point-5' ) {
      position = target.offset().top  + 500;
    } else if ( href == '#li-point-2' ) {
      position = target.offset().top  - 100;
    } else if ( href == '#li-point-3' ) {
      position = target.offset().top - 20;
    }
  }
  $('body,html').animate({scrollTop:position}, speed, 'swing');
  return false;
});

if (window.matchMedia("(max-width: 768px)").matches) {
  
$(window).scroll(function () {
  scrollHeight = $(document).height();
  scrollPosition = $(window).height() + $(window).scrollTop();
  footHeight = $("footer").innerHeight();

  if ( scrollHeight - scrollPosition  <= footHeight ) {
      $('.history-list-menu').css('position', 'absolute');
      $('.history-list-menu').css('bottom', 'footHeight + 20');
      $('.history-list-menu').css('transition', '1.5s');
  } else if ( scrollPosition < 700 ) {
      $('.history-list-menu').css('position', 'fixed');
      $('.history-list-menu').css('top', '240px');
      $('.history-list-menu').css('transition', '1.5s');
      $('.history-list-menu').css('background', 'none');
      $('.brand-title-area').css('position', 'relative');
      $('.brand-title-area').css('top', 'auto');
      $('.brand-title-area').css('transition', '1.5s');
      $('.brand-title-area').css('background', 'none');
  } else {
      $('.brand-title-area').css('position', 'fixed');
      $('.brand-title-area').css('top', '40px');
      $('.brand-title-area').css('background', '#000');
      $('.brand-title-area').css('transition', '1.5s');
      $('.brand-title-area').css('width', '100%');
      $('.brand-title-area').css('z-index', '50');
      $('.history-list-menu').css('transition', '1.5s');
      $('.history-list-menu').css('background', '#000');
      $('.history-list-menu').css('position', 'fixed');
      $('.history-list-menu').css('top', '150px');
      $('.history-list-menu').css('left', '0px');
      $('.history-list-menu').css('transition', '1s');
  }
});
}

const history = new Swiper('.brand-history-contents .swiper', {
  loop: true,
  speed: 3000,
  effect: 'fade',
  spaceBetween: 0,
  slidesPerView: 1,
    breakpoints: {
    640: {
      slidesPerView: 1,
    }
  },
  autoplay: {
    delay: 2000,
    disableOnInteraction: false,
  },
  pagination: {
    el: ".brand-history-contents .swiper-pagination",
    clickable: true,
  },
  centeredSlides : false,
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["admiral-brand-initial"] && !Shopify.designMode) return;
  try {
    
  AOS.init({
    once: true,
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["admiral-brand-slider"] && !Shopify.designMode) return;
  try {
    
const brand = new Swiper('.brand-slider .swiper', {
  loop: true,
  speed: 400,
  grabCursor: true,
  spaceBetween: 0,
  slidesPerView: 1.1,
    breakpoints: {
    640: {
      slidesPerView: 1.8,
    }
  },
  navigation: {
    nextEl: '.brand-slider .swiper-button-next',
    prevEl: '.brand-slider .swiper-button-prev',
  },
  centeredSlides : true,
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["admiral-feature-slider"] && !Shopify.designMode) return;
  try {
    
const feature = new Swiper('.feature-slider .swiper', {
  loop: true,
  speed: 2000,
  spaceBetween: 20,
  slidesPerView: 1.2,
    breakpoints: {
    640: {
      slidesPerView: 3.4,
    }
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  centeredSlides : false,
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["admiral-journal"] && !Shopify.designMode) return;
  try {
    
  AOS.init({
    once: true,
  });

  const slides =$(".img-wrap").find("img");
  const slideLength = slides.length;
  const pagenation_line = $(".pagenation-line");
  
  if( slideLength > 1) {
    let now = 0;
    let next = 1;
    const fade = 2000;
    const show = 5000;
    slides.hide();
    pagenation_line.css('background-color', '#fff');
    slides.eq(0).show();
    pagenation_line.eq(0).css('background-color', '#DB1633');
    timerId = setInterval(function(){
      slides.eq(now % slideLength).fadeOut(fade);
      pagenation_line.css('background-color', '#fff');
      slides.eq(next % slideLength).fadeIn(fade);
      pagenation_line.eq(next % slideLength).css('background-color', '#DB1633');
      now++;
      next++;
    }, show);
  }
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["admiral-jurnal-interview-vol09"] && !Shopify.designMode) return;
  try {
    
  AOS.init({
    once: true,
  });

  const slides =$(".img-wrap").find("img");
  const slideLength = slides.length;
  const pagenation_line = $(".pagenation-line");
  
  if( slideLength > 1) {
    let now = 0;
    let next = 1;
    const fade = 2000;
    const show = 5000;
    slides.hide();
    pagenation_line.css('background-color', '#fff');
    slides.eq(0).show();
    pagenation_line.eq(0).css('background-color', '#DB1633');
    timerId = setInterval(function(){
      slides.eq(now % slideLength).fadeOut(fade);
      pagenation_line.css('background-color', '#fff');
      slides.eq(next % slideLength).fadeIn(fade);
      pagenation_line.eq(next % slideLength).css('background-color', '#DB1633');
      now++;
      next++;
    }, show);
  }
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["admiral-jurnal-interview"] && !Shopify.designMode) return;
  try {
    
  AOS.init({
    once: true,
  });

  const slides =$(".img-wrap").find("img");
  const slideLength = slides.length;
  const pagenation_line = $(".pagenation-line");
  
  if( slideLength > 1) {
    let now = 0;
    let next = 1;
    const fade = 2000;
    const show = 8000;
    slides.hide();
    pagenation_line.css('background-color', '#fff');
    slides.eq(0).show();
    pagenation_line.eq(0).css('background-color', '#DB1633');
    timerId = setInterval(function(){
      slides.eq(now % slideLength).fadeOut(fade);
      pagenation_line.css('background-color', '#fff');
      slides.eq(next % slideLength).fadeIn(fade);
      pagenation_line.eq(next % slideLength).css('background-color', '#DB1633');
      now++;
      next++;
    }, show);
  }
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["admiral-movie-slider"] && !Shopify.designMode) return;
  try {
    
const movie = new Swiper('.movie-slider .swiper', {
  loop: true,
  speed: 2000,
  spaceBetween: 20,
  slidesPerView: 1.2,
    breakpoints: {
    640: {
      slidesPerView: 3.4,
    }
  },
  autoplay: {
    delay: 2000,
    disableOnInteraction: true
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  centeredSlides : false,
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["admiral-related-article"] && !Shopify.designMode) return;
  try {
    

const jurnal = new Swiper('.admiral-related-article .swiper', {
  loop: false,
  speed: 2000,
  spaceBetween: 40,
  slidesPerView: 1.5,
    breakpoints: {
    640: {
      slidesPerView: 5,
    }
  },
  centeredSlides : false,
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["admiral-short-movie"] && !Shopify.designMode) return;
  try {
    
const short_movie = new Swiper('.short_movie.swiper-container', {
  loop: true,
  speed: 1000,
  autoplay: {
    delay: 5000,
  },
  spaceBetween: 15,
  slidesPerView: 1,
    breakpoints: {
    640: {
      slidesPerView: 5,
    }
  },
  centeredSlides : false,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  on: {
    transitionStart: function(){
      var videos = document.querySelectorAll('video');
      Array.prototype.forEach.call(videos, function(video){
        video.pause();
      });
    },
    transitionEnd: function(){
      
      var activeIndex = this.activeIndex;
      var activeSlide = document.getElementsByClassName('movie_item_sp')[activeIndex];
      var activeSlideVideo = activeSlide.getElementsByTagName('video')[0];
      activeSlideVideo.play();
    },
  }
});

short_movie.autoplay.stop();
    $(window).on('scroll', function () {
        let position = $('.short_movie.swiper-container').offset().top - $(window).innerHeight(),
            scrollTop = $(window).scrollTop(); 
        if(scrollTop > position) {
            short_movie.autoplay.start();
        }else{
            short_movie.autoplay.stop();
        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["admiral-slide-news"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const sliderElement = document.querySelector('.admiral_news_slider .swiper');
  if (!sliderElement) return;

  new Swiper(sliderElement, {
    speed: 600,
    spaceBetween: 0,
    slidesPerView: 1,
    watchOverflow: true,
    allowTouchMove: true,
    simulateTouch: true,
    grabCursor: true,
    touchRatio: 1,
    touchAngle: 45,
    pagination: {
      el: '.admiral_news_slider .swiper-pagination',
      clickable: true
    },
    centeredSlides: false,
    breakpoints: {
      769: {
        spaceBetween: 30,
        slidesPerView: 5.5,
        allowTouchMove: true,
        simulateTouch: true,
        grabCursor: true
      }
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["test"] && !Shopify.designMode) return;
  try {
    
if (window.matchMedia('(min-width: 768px)').matches) {
const admiral_news_slider = new Swiper('.admiral_news_slider .swiper', {
  loop: true,
  speed: 2000,
  spaceBetween: 30,
  slidesPerView: 1.2,
    breakpoints: {
    640: {
      slidesPerView: 4.5,
    }
  },
  autoplay: {
    delay: 2000,
    disableOnInteraction: false
  },
  centeredSlides : false,
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uno-exclusive-hero"] && !Shopify.designMode) return;
  try {
    
  AOS.init({
    once: true,
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uno-exclusive-hero2"] && !Shopify.designMode) return;
  try {
    
  AOS.init({
    once: true,
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uno-exclusive-products"] && !Shopify.designMode) return;
  try {
    
  AOS.init({
    once: true,
  });

  } catch(e) { console.error(e); }
})();
})();
